// src/theme/atomic/coolNeutral.ts
var coolNeutral = {
  5: "#0F0F10",
  7: "#141415",
  10: "#171719",
  15: "#1B1C1E",
  17: "#212225",
  20: "#292A2D",
  22: "#2E2F33",
  23: "#333438",
  25: "#37383C",
  30: "#46474C",
  40: "#5A5C63",
  50: "#70737C",
  60: "#878A93",
  70: "#989BA2",
  80: "#AEB0B6",
  90: "#C2C4C8",
  95: "#DBDCDF",
  96: "#E1E2E4",
  97: "#EAEBEC",
  98: "#F4F4F5",
  99: "#F7F7F8"
};
var coolNeutral_default = coolNeutral;

export { coolNeutral_default as default };
